export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q05_a.c8b64592.png";